/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileRequest } from '../models/FileRequest';
import type { IssueCreate } from '../models/IssueCreate';
import type { OutboxEvent } from '../models/OutboxEvent';
import type { ReportSummary } from '../models/ReportSummary';
import type { ServiceInfo } from '../models/ServiceInfo';
import type { SyncEventRequest } from '../models/SyncEventRequest';
import type { ValidationResponse } from '../models/ValidationResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminService {
    /**
     * List Gage Lengths
     * List all available gage lengths.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listGageLengths(): CancelablePromise<Array<Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/gagelengths',
        });
    }
    /**
     * List Sensor Spacings
     * List all available sensor spacings.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listSensorSpacings(): CancelablePromise<Array<Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/sensorspacings',
        });
    }
    /**
     * List Services
     * List all available services.
     * @returns ServiceInfo Successful Response
     * @throws ApiError
     */
    public static listServices(): CancelablePromise<Array<ServiceInfo>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/services',
        });
    }
    /**
     * List Sync Services
     * List all available sync-services.
     * @returns ServiceInfo Successful Response
     * @throws ApiError
     */
    public static listSyncServices(): CancelablePromise<Array<ServiceInfo>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/sync-services',
        });
    }
    /**
     * List Services
     * List all available services.
     * @returns ServiceInfo Successful Response
     * @throws ApiError
     */
    public static listServices1(): CancelablePromise<Array<ServiceInfo>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/obr-services',
        });
    }
    /**
     * Download
     * Download a file from S3 bucket. The bucket name is case-insensitive and should match one of the predefined BucketType values.
     * @param bucket
     * @param key
     * @returns any Successful Response
     * @throws ApiError
     */
    public static downloadFileFromS3(
        bucket: string,
        key: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/objects/{bucket}/{key}',
            path: {
                'bucket': bucket,
                'key': key,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Buckets
     * List all available S3 buckets.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static listBuckets(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/buckets',
        });
    }
    /**
     * Get Logs
     * Get current logs snapshot. This returns the current contents of the log buffer as a JSON response. Useful for debugging and monitoring purposes.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getLogs(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/logs',
        });
    }
    /**
     * Get Obrlogs
     * Get current OBR logs snapshot. This returns the current contents of the log buffer as a JSON response. Useful for debugging and monitoring purposes.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getObrlogs(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/obrlogs',
        });
    }
    /**
     * Stream Obrlogs
     * Stream logs in real-time using Server-Sent Events (SSE). This endpoint keeps the connection open and sends new log entries to the client as they are added to the log buffer. Useful for real-time monitoring of application logs.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static streamObrlogs(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/obrlogs/stream',
        });
    }
    /**
     * Stream Logs
     * Stream logs in real-time using Server-Sent Events (SSE). This endpoint keeps the connection open and sends new log entries to the client as they are added to the log buffer. Useful for real-time monitoring of application logs.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static streamLogs(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/logs/stream',
        });
    }
    /**
     * Create Jira Issue
     * Create a Jira issue in the project specified in settings with the provided title and body. This can be used by the frontend to allow users to report bugs or request features directly from the UI.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postJiraIssue(
        requestBody: IssueCreate,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/jira-issue',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Issue
     * Create a GitHub issue in the repository specified in settings with the provided title and body. This can be used by the frontend to allow users to report bugs or request features directly from the UI.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postGithubIssue(
        requestBody: IssueCreate,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/issue',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete All Collections
     * ⚠️ DANGER: Delete all collections in the database.
     *
     * This is an extremely destructive operation that will permanently delete
     * ALL data from ALL collections in the database. This cannot be undone.
     *
     * Args:
     * confirm: Must be set to "DELETE_ALL_DATA" to proceed
     *
     * Returns:
     * dict: List of deleted collections and count
     *
     * Raises:
     * HTTPException: If confirmation parameter is incorrect
     * @param confirm
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteAllCollectionsApiAdminCollectionsAllDelete(
        confirm: string,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/collections/all',
            query: {
                'confirm': confirm,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete All Collections
     * ⚠️ DANGER: Delete all collections in the database.
     *
     * This is an extremely destructive operation that will permanently delete
     * ALL data from ALL collections in the database. This cannot be undone.
     * Returns:
     * dict: List of deleted collections and count
     *
     * Raises:
     * HTTPException: If confirmation parameter is incorrect
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteAllCollectionsApiAdminClearDelete(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/clear',
        });
    }
    /**
     * Post Inbox
     * Endpoint to receive sync events from other system. This is the inbox for sync events. The outbox event contains a sync url from which we get files to process and save in our system.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postInboxApiAdminInboxPost(
        requestBody: Array<OutboxEvent>,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/inbox',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Outbox
     * Endpoint to get all outbox events that need to be sent to other system. This is the outbox for sync events. The outbox event contains a sync url from which the other system can get files to process and save in their system.
     * @param unprocessed
     * @returns OutboxEvent Successful Response
     * @throws ApiError
     */
    public static getOutboxApiAdminOutboxGet(
        unprocessed?: (string | null),
    ): CancelablePromise<Array<OutboxEvent>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/outbox',
            query: {
                'unprocessed': unprocessed,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Database Hash
     * Get the hash of the database. This can be used to check if the database has changed since last sync.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getDatabaseHash(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/hash',
        });
    }
    /**
     * Truncate Database
     * Truncate the database. This will delete all data in the database and reset it to an empty state. Use with caution.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static truncateDatabase(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/truncate',
        });
    }
    /**
     * Get List All Files
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getListAllFilesApiAdminListFilesGet(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/list-files',
        });
    }
    /**
     * Sync All Data
     * @param requestBody
     * @returns ReportSummary Successful Response
     * @throws ApiError
     */
    public static postSync(
        requestBody: SyncEventRequest,
    ): CancelablePromise<Array<ReportSummary>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/sync',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Sync All Data
     * @param requestBody
     * @returns ValidationResponse Successful Response
     * @throws ApiError
     */
    public static postSyncCheck(
        requestBody: SyncEventRequest,
    ): CancelablePromise<ValidationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/sync/check',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Sync File
     * @returns any Successful Response
     * @throws ApiError
     */
    public static uploadSyncFileApiAdminUploadsyncPost(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/uploadsync',
        });
    }
    /**
     * Get File Content
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getFileContentApiAdminFileGet(
        requestBody: FileRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/file',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
